export const podColors = {
  images: `#70D292`,
  signatures: `#6A91DE`,
  comments: `#81CFDC`,
};

export const timeOnRouteColors = [`#80C2BB`, `#FFC2A2`, `#E64C5B`, `#373D75`, `#C1C7F5`];

export const cancelReasonColors = {
  nobody: `#E03030`,
  wrong_address: `#F5AF95`,
  missing_information: `##E64C5B`,
  other: `#ED9A9A`,
};

export default {};
